export enum DashboardEnum {
  operationsClawChart = 'MachineHome/ClawOperationsChart', // 取得店家選物機圖表
  operationsClawChartV2 = 'v2/MachineHome/ClawOperationsChart', // 新系統：取得店家選物機圖表
  operationsCoinChart = 'MachineHome/CoinOperationsChart', // 取得店家兌幣機圖表
  operationsCoinChartV2 = 'v2/MachineHome/CoinOperationsChart', // 新系統：取得店家兌幣機圖表
  clawOperationsInfo = 'MachineHome/ClawOperationsInfo', // 取得店家選物機運營清單
  clawOperationsInfoV2 = 'v2/MachineHome/ClawOperationsInfo', // 新系統：取得店家選物機運營清單
  coinOperationsInfo = 'MachineHome/CoinOperationsInfo', // 取得店家兌幣機運營清單
  coinOperationsInfoV2 = 'v2/MachineHome/CoinOperationsInfo', // 新系統：取得店家兌幣機運營清單
  machineAction = 'MachineHome/MachineAction', // 機台操作
  machineDelAccount = 'MachineHome/MachineDelAcc', // 清除特定機器所有帳目功能
  coinRetrievalAction = 'MachineHome/CoinRetrievalAction', // 選物機錢箱收款
  coinRetrievalActionV2 = 'v2/MachineHome/CoinRetrievalAction' // 新系統：選物機錢箱收款
}
